/* global moment */
import { formatDisplayDateFromStore, formatDisplayWeekdayFromStore } from './dateFormatters'

/**
 * Valida si una cadena es una fecha válida en formato YYYY-MM-DD.
 * @param {string} dateString
 * @returns {boolean}
 */
export function isValidDate(dateString) {
    return moment(dateString, 'YYYY-MM-DD', true).isValid()
}

/**
 * Formatea una fecha o nombre de día de la semana para visualización.
 * Si date es YYYY-MM-DD válido: "lunes 01/03" (selector contextual).
 * Si date es weekday en inglés (sunday, monday...): nombre localizado.
 * @param {string} date - Fecha YYYY-MM-DD o nombre de día en inglés
 * @returns {string}
 */
export function formatDate(date) {
    if (isValidDate(date)) {
        return formatDisplayWeekdayFromStore(date, 'long') + ' ' + formatDisplayDateFromStore(date, { style: 'contextual' })
    }
    const englishWeekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
    const weekdayIndex = englishWeekdays.indexOf(date)
    return weekdayIndex < 0 ? date : formatDisplayWeekdayFromStore(moment('2026-04-12').add(weekdayIndex, 'days'), 'long')
}
